import React from 'react';
import { MenuAction } from '@/types/MenuTypes';
import { MenubarItem, MenubarShortcut } from '@/components/ui/menubar';

interface DynamicMenuProps {
  actions: MenuAction[];
  onActionClick: (actionId: string) => void;
  className?: string;
  isNightTime?: boolean;
}

export const DynamicMenu: React.FC<DynamicMenuProps> = ({ 
  actions, 
  onActionClick, 
  className,
  isNightTime = false
}) => {
  const renderMenuAction = (action: MenuAction) => {
    if (action.separator) {
      return (
        <div key={action.id} className={`h-px ${isNightTime ? 'bg-slate-600/40' : 'bg-white/60'} my-1`} />
      );
    }

    return (
      <MenubarItem
        key={action.id}
        onClick={() => action.onClick ? action.onClick() : onActionClick(action.id)}
        disabled={action.disabled}
        className={`text-white/95 ${isNightTime ? 'hover:bg-slate-700/30' : 'hover:bg-amber-800/30'} hover:text-white transition-all duration-100 rounded-md px-3 py-1.5 font-medium cursor-default text-sm flex justify-between ${action.disabled ? 'opacity-50' : ''} ${className || ''}`}
      >
        <span className="flex items-center gap-2">
          {action.checked !== undefined && (
            <span className="w-4 h-4 flex items-center justify-center">
              {action.checked && '✓'}
            </span>
          )}
          {action.label}
        </span>
        {action.shortcut && (
          <MenubarShortcut className="text-white/60 font-mono text-xs">
            {action.shortcut}
          </MenubarShortcut>
        )}
      </MenubarItem>
    );
  };

  return (
    <>
      {actions.map(renderMenuAction)}
    </>
  );
};